import React from "react";
import { array, bool, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import LinkTag from "../../molecules/link-tag";
import Headline from "../../atoms/headline";
import CardImage from "../../atoms/cardimage";
import DoubleRightIcon from "../../atoms/icons/double-angle-right";
import CustomStoryCard5 from "../../molecules/custom-story-card5";

import "./threeStory.m.css";

const ThreeStory = ({ list, isHeadlineRequired, collectionName, collectionSlug, isExternalStory, pageType }) => {
  if (!(list && list.length)) {
    return null;
  }

  const [firstStory, ...remainingStories] = list;

  const getHeadlineView = () => (
    <div styleName="headline">
      <LinkTag href={collectionSlug} isExternalStory={isExternalStory}>
        <Headline text={collectionName || ""} headerType={6} headerLevel={3} />
      </LinkTag>
      {pageType === "home-page" && (
        <LinkTag href={collectionSlug} isExternalStory={isExternalStory}>
          <DoubleRightIcon />
        </LinkTag>
      )}
    </div>
  );

  return (
    <div styleName="wrapper" id={collectionSlug}>
      {isHeadlineRequired && getHeadlineView()}

      <LinkTag href={firstStory.url} isExternalStory={isExternalStory}>
        <CardImage
          story={firstStory}
          aspectRatio={[16, 9]}
          imageType="image16x9"
          widths={[450]}
          eager={true}
          showHeadline={true}
          showStoryTypeIcon
        />
      </LinkTag>

      <div styleName="stories">
        {remainingStories.splice(0, 2).map((item, index) => (
          <CustomStoryCard5 story={item} key={index} isExternalStory={isExternalStory} />
        ))}
      </div>
    </div>
  );
};

ThreeStory.defaultProps = {
  isHeadlineRequired: true,
  isExternalStory: false,
};

ThreeStory.propTypes = {
  list: array.isRequired,
  isHeadlineRequired: bool,
  collectionName: string,
  collectionSlug: string,
  isExternalStory: bool,
  pageType: string,
};

const mapStateToProps = (state) => ({
  pageType: get(state, ["qt", "pageType"], null),
});

export default connect(mapStateToProps, null)(ThreeStory);
